import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  NotificationActionContract,
  NotificationAngularRouteActionContract,
} from '../../contracts/notification-action.contract';
import { Handler } from './handler.type';

export function createAngularRouteNotificationActionHandler(): Handler<NotificationAngularRouteActionContract> {
  const router = inject(Router);

  return {
    handle: (action: NotificationAngularRouteActionContract) => handleAngularRoute(action, router),
    support: isNotificationAngularRouteActionContract,
  };
}

function isNotificationAngularRouteActionContract(
  action: NotificationActionContract,
): action is NotificationAngularRouteActionContract {
  return 'route' in action;
}

export function handleAngularRoute(
  action: NotificationAngularRouteActionContract,
  router: Router,
): Promise<void> {
  return router.navigate(action.route).then();
}
